import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CreateProduct } from 'src/app/modules/product/components/edit-fund/create-product';
import { ParseDataService } from 'src/app/modules/product/services/parseData.service';
import { Product } from '../../models/product.model';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { EventManager } from 'src/app/core';
import { Constant } from 'src/app/core/constant';
import { Fee } from '../../models/fee.model';
import { FeeTransferComponent } from '../fee-transfer/fee-transfer.component';
declare let $: any;
@Component({
  selector: 'app-set-up-new-fee-fund',
  templateUrl: './set-up-new-fee-fund.component.html',
  styleUrls: ['./set-up-new-fee-fund.component.scss'],
  providers: [ValidateService, DataService],
})
export class SetUpNewFeeFundComponent extends CreateProduct implements OnInit, OnDestroy {
  @ViewChild(FeeTransferComponent, { static: true }) feeTransferTempComponent: FeeTransferComponent;
  id: number;
  sipId: number;
  subscriptions: Subscription[] = [];
  listFee: any[] = [];
  feeBuys: any[] = [];
  feeSells: any[] = [];
  feeTransferTemp: any[] = [];
  currentFeeBuys: any[] = [];
  currentFeeSells: any[] = [];
  Constant = Constant;
  startDateBuyFee: any;
  startDateSellFee: any;
  startDateTransferFee: any;
  programType: any;
  isSIP: boolean = false;
  sourcePrograms: any[] = [{id: 1, name: 'Linh Hoạt', code: 'NORMAL'}, { id: 2, name: 'Định kỳ', code: 'SIP'}];
  TABS = {
    BUY_FEE: 'BUY_FEE',
    SELL_FEE: 'SELL_FEE',
    TRANSFER_FEE: 'TRANSFER_FEE',
  };
  tab: string = this.TABS.BUY_FEE;
  constructor(
      public router: Router,
      public route: ActivatedRoute,
      public productService: ProductService,
      public dataService: DataService,
      public masterDataProductService: MasterDataProductService,
      public toastrService: ToastrService,
      private eventManager: EventManager,
  ) {
    super(dataService);
  }
  ngOnInit() {
    this.product = new Product();
    const data = this.route.snapshot.data;
    this.isSIP = data.isSip;
    if (data.isSip) {
      this.programType = this.sourcePrograms[1];
    } else {
      this.programType = this.sourcePrograms[0];
    }

    super.ngOnInit('CODE_TRADING_FUND');
    this.subscriptions = [];
  
    this.getMasterData();
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getMasterData() {
    forkJoin(
      this.getRelationalOperator(),
    )
    .subscribe((results) => {
        this.complete(results);
    });
  }
  getRelationalOperator() {
    return this.masterDataProductService.getRelationalOperator()
    .pipe(map((res: any) => {
      this.resource.relationalOperators = res.list || [];
      this.resource.relationalOperators.forEach((operator) => {
        switch (operator.name) {
          case '<=':
          operator.reverseOperator = '>=';
          break;
          case '<':
          operator.reverseOperator = '>';
          break;
          case '>=':
          operator.reverseOperator = '<=';
          break;
          case '>':
          operator.reverseOperator = '<';
          break;
        }
      });
      return res;
    }));
  }
  complete(array) {
    const params = this.route.snapshot.params;
    this.id = params.id;
    this.sipId = params.sipId;
    if (this.id) {
      if (this.isSIP) {
        this.getDetailSIP();
      } else {
        this.getDetailProduct();
      }
    }
    this.getResource();
  }
  getDetailProduct() {
    this.productService.find(this.id)
    .subscribe(
      (res: any) => {
        const product = res.body.data;
        this.product = new Product(product);
        this.product.listFee = product.listFee;
        const listFee = (this.product.listFee || {});
        this.currentFeeBuys = (listFee.BUYFeeList || []).map((item, index) => {
          return new Fee(item) ;
        });
        this.currentFeeSells = (listFee.SELLFeeList || []).map((item, index) => {
          return new Fee(item) ;
        });
        this.getFee();
      }
    );
  }
  getDetailSIP() {
    this.productService.findProgram(this.sipId)
    .subscribe(
      (res: any) => {
        const productProgram = (res.body.data || {}).productProgram;
        this.product = productProgram.product;
        const listFee = (productProgram.listFee || {});
        this.currentFeeBuys = (listFee.BUYFeeList || []).map((item, index) => {
          return new Fee(item) ;
        });
        this.currentFeeSells = (listFee.SELLFeeList || []).map((item, index) => {
          return new Fee(item) ;
        });
        this.getFee();
      }
    );
  }
  getFee() {
    const body = {
      "productId": this.id,
      "schemeId": this.programType.id
    }
    this.productService.getProductFeeTemp(body)
    .subscribe(
      (res: any) => {
        const data = res.data || {list: []};
        if (!data.list.length) {
          return;
        }
        this.listFee = data.list;

        this.feeBuys = this.listFee
        .filter((item, index) => {
          return item.typeCode === 'BUY';
        })
        .map((item, index) => {
          return new Fee(item) ;
        });
        this.startDateBuyFee = this.feeBuys.length ? this.feeBuys[0].applyAt : null;

        this.feeSells = this.listFee
        .filter((item, index) => {
          return item.typeCode === 'SELL';
        })
        .map((item, index) => {
          return new Fee(item) ;
        });
        this.startDateSellFee = this.feeSells.length ? this.feeSells[0].applyAt : null;
       
        this.feeTransferTemp = this.listFee.filter((item, index) => {
          return item.typeCode === 'TRANSFER';
        }).map((item, index) => {
          return new Fee(item) ;
        });
        this.startDateTransferFee = this.feeTransferTemp.length ? this.feeTransferTemp[0].applyAt : null;
      }
    );
  }
  getTransferList(data) {
    const list = this.feeTransferTemp.filter((fee) => {
      return fee.destProductId == data.destProductId;
    });
    this.eventManager.broadcast({
      name: 'get-transfer-list-result',
      content: list
    })
  }
  selectTab(event) {
    switch (event.index) {
      case 0:
        this.tab = this.TABS.BUY_FEE;
      break;
      case 1:
        this.tab = this.TABS.SELL_FEE;
      break;
      case 2:
        this.tab = this.TABS.TRANSFER_FEE;
      break;
    }
  }
}
